import CommonUtils from './common';

const DOMUtils = {
    // 根据class 向父级元素查找
    getParentByClass(target, className) {
        let p = target;
        const indexOf = Array.prototype.indexOf;
        while (p && indexOf.call(p.classList || [], className) == -1 ) {
            p = p.parentNode;
        }
        return p;
    },
    /**
     * 元素是否包含需要查询的class
     * @param {*} el  当前DOM
     * @param {*} cls  class名称
     */
    hasClass(el, cls) {
        if (!el || !cls) return false;
        if (cls.indexOf(' ') !== -1) {
            throw new Error('className should not contain space.');
        }
        if (el.classList) {
            return el.classList.contains(cls);
        } else {
            return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
        }
    },

    /**
     * 添加class
     * @param {*} el DOM对象
     * @param {*} cls class名称
     */
    addClass(el, cls) {
        if (!el) return;
        let curClass = el.className;
        let classes = (cls || '').split(' ');

        for (let i = 0, j = classes.length; i < j; i++) {
            let clsName = classes[i];
            if (!clsName) continue;

            if (el.classList) {
                el.classList.add(clsName);
            } else if (!DOMUtils.hasClass(el, clsName)) {
                curClass += ' ' + clsName;
            }
        }
        if (!el.classList) {
            el.className = curClass;
        }
    },

    /**
     * 移除class
     * @param {*} el Dom对象
     * @param {*} cls class名称
     */
    removeClass(el, cls) {
        if (!el || !cls) return;
        let classes = cls.split(' ');
        let curClass = ' ' + el.className + ' ';

        for (let i = 0, j = classes.length; i < j; i++) {
            let clsName = classes[i];
            if (!clsName) continue;

            if (el.classList) {
                el.classList.remove(clsName);
            } else if (DOMUtils.hasClass(el, clsName)) {
                curClass = curClass.replace(' ' + clsName + ' ', ' ');
            }
        }
        if (!el.classList) {
            el.className = CommonUtils.trim(curClass);
        }
    }
};
export default DOMUtils;
